import React, { useEffect, useState } from "react";
import { Card, CardBody, InputGroup, Col, Form, Row, Button } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import { getCurrentDay } from "../../helpers/utils";
import CustomMultipleDateRange from "../CustomMultipleDateRange/CustomMultipleDateRange";
import { AvForm } from "availity-reactstrap-validation";
import { debounce } from "lodash";

const DynamicFormToFilterUpdated = props => {
  const [date, setDate] = useState();
  const [filters, setFilters] = useState({});

  useEffect(() => {
    const { selectedDate } = props;
    setDate({
      start_date:
        selectedDate !== null
          ? selectedDate.start_date
          : new Date(new Date().setDate(1)).toISOString().split("T")[0],
      end_date: selectedDate !== null ? selectedDate.end_date : getCurrentDay(),
    });

    return () => {
      setDate({
        start_date: new Date(new Date().setDate(1)).toISOString().split("T")[0],
        end_date: getCurrentDay(),
      });
    };
  }, []);

  useEffect(() => {
    const { selectedDate } = props;
    setDate({
      start_date:
        selectedDate !== null
          ? selectedDate.start_date
          : new Date(new Date().setDate(1)).toISOString().split("T")[0],
      end_date: selectedDate !== null ? selectedDate.end_date : getCurrentDay(),
    });
  }, [props.selectedDate]);

  const handleSelect = (data, filterType) => {
    let filteredData = {};
    filteredData[filterType] = [];

    if (Array.isArray(data)) {
      data.map(i => filteredData[filterType].push(i.value));
    } else {
      filteredData[filterType].push(data.value);
    }

    // const update_date = {
    //   ...filteredData,
    //   start_date: date.start_date,
    //   end_date: date.end_date || getCurrentDay(),
    // };

    setFilters(prev => ({
      ...prev,
      ...date,
      [filterType]: filteredData[filterType],
    }));

    // if (date.end_date !== undefined) {
    // console.log(update_date, filterType);
    // props.onFiltersChange("data", update_date, filterType);
    // }
  };

  const debouncedHandleFiltersChange = debounce(newFilters => {
    Object.keys(newFilters).length > 0 &&
      props.onFiltersChange(filters, "filters");
  }, 500);

  React.useEffect(() => {
    debouncedHandleFiltersChange(filters);
  }, [filters]);

  const onFiltersChange = fiterDate => {
    setDate({ ...fiterDate });

    const data = {
      start_date: fiterDate.start_date,
      end_date: fiterDate.end_date || getCurrentDay(),
    };

    if (fiterDate.end_date !== undefined) {
      props.onFiltersChange(data);
    }
  };

  const handleSetDefaultDate = (params, date_type) => {
    let date = "";
    if (
      params[date_type[0]] !== undefined &&
      params[date_type[1]] !== undefined
    ) {
      let current = {
        start_date: new Date(params[date_type[0]]),
        end_date: new Date(params[date_type[1]]),
      };
      const selectedDate = {
        start_date:
          new Date(current.start_date.setHours(12)).toJSON().split("T")[0] ||
          "",
        end_date:
          new Date(current.end_date.setHours(12)).toJSON().split("T")[0] || "",
      };
      date = selectedDate["start_date"] + " to " + selectedDate["end_date"];
      return {
        start_date: selectedDate["start_date"],
        end_date: selectedDate["end_date"],
      };
    }
  };

  return (
    <StyledRow>
      <Col className="col-12">
        <StyledCard>
          <CardBody
            style={{
              padding: "1.25rem 0",
              ...props.style,
            }}
          >
            <FilterContainer className="d-flex justify-content-between align-items-end">
              <div>
                {props.filtersFields && (
                  <div className="col-sm-auto mb-2">
                    <span>Filter by: </span>
                  </div>
                )}
                <div className="row gy-1 gx-1 align-items-center">
                  {props.filtersFields &&
                    props.filtersFields.map((i, key) => (
                      <div className="col-sm-auto" key={key}>
                        <DefaultMultipleSelect
                          options={
                            i.filterData?.length > 0
                              ? i.filterData.map(item => ({
                                  key: item?.id || item,
                                  text: item?.name || item,
                                  checked: item?.checked || false,
                                }))
                              : []
                          }
                          filtered_by={props.filtered_by[key]}
                          filtered_params={props.filtered_params}
                          onChange={select =>
                            handleSelect(select, i.filterType)
                          }
                          plug={i.plug}
                          search
                        />
                      </div>
                    ))}
                </div>
              </div>
              <div>
                <div className="gy-2 gx-1 d-flex gap-3 float-end">
                  <div
                    style={{
                      width: "100%",
                      height: 37,
                    }}
                  >
                    <Button
                      color="primary"
                      className={`${
                        props.report_type == "quality-report" ? "" : "d-none"
                      }`}
                      onClick={props.updateReportData}
                      style={{
                        height: "100%",
                        minWidth: "215px",
                        margin: "26px 0 0 0",
                      }}
                    >
                      <i className="mdi mdi-refresh" /> Update dashboard data
                    </Button>
                  </div>
                  <PickerStyled>
                    <p>Date range:</p>
                    <AvForm>
                      <CustomMultipleDateRange
                        // value={date}
                        value={
                         props.selectedDate
                        }
                        placeholder="Select date range..."
                        name="date-range-picker-1"
                        datePickerType="round"
                        onChange={date => onFiltersChange(date)}
                        customStaticRanges={props.customStaticRanges}
                      />
                    </AvForm>
                  </PickerStyled>
                </div>
              </div>
            </FilterContainer>
          </CardBody>
        </StyledCard>
      </Col>
    </StyledRow>
  );
};

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  max-width: 220px;
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

DynamicFormToFilterUpdated.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  data: PropTypes.any,
  filtersFields: PropTypes.any,
  selectedDate: PropTypes.any,
  autoCheckedAll: PropTypes.bool,
  filtered_params: PropTypes.object,
  filtered_by: PropTypes.array,
  style: PropTypes.object,
  updateReportData: PropTypes.func,
  report_type: PropTypes.string,
  customStaticRanges: PropTypes.bool,
  dateValue: PropTypes.object,
};

export default DynamicFormToFilterUpdated;
